import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import SelectFileDialog from 'app/components/drive/SelectFileDialog';
import EditImageDialog from 'app/components/dialogs/EditImageDialog';
import HeaderImage from 'app/components/pages/HeaderImage';
import RedButton from 'app/components/buttons/RedButton';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    section: {
        marginBottom: theme.spacing(3)
    },
    formContainer: {
        overflowY: 'scroll',
        height: '100%',
        padding: theme.spacing(3)
    },
    mobileContainer: {
        height: '100%',
        padding: theme.spacing(3)
    },
    marginLeft: {
        marginLeft: theme.spacing(1)
    },
    marginBottom: {
        marginBottom: theme.spacing(1)
    },
}));

export default function EventImage(props) {

    const {
        event,
        getEvent,
        loading,
        setLoading
    } = props;

    const classes = useStyles();
    const api = useApi();

    const [ editFileDialogOpen, setEditFileDialogOpen ] = useState(false);
    const [ editImageDialogOpen, setEditImageDialogOpen ] = useState(false);

    // File Dialog ------------------------------------------

    const openEditFileDialog = () => {
        setEditFileDialogOpen(true);
    }

    const closeEditFileDialog = () => {
        setEditFileDialogOpen(false);
    }

    const closeEditFileDialogAndRefresh = (image) => {
        setEditFileDialogOpen(false);
        setLoading(true);

        api.post(`/admin/event/${event.id}/image`, {image_id: image.id})
            .then(() => getEvent())
            .catch(() => setLoading(false));
    }

    const deleteImage = () => {
        setLoading(true);

        api.delete(`/admin/event/${event.id}/image`)
            .then(() => getEvent())
            .finally(() => setLoading(false));
    }

    // Image Dialog ----------------------------------------

    const openEditImageDialog = () => {
        setEditImageDialogOpen(true);
    }

    const closeEditImageDialog = () => {
        setEditImageDialogOpen(false);
    }

    const closeEditImageDialogAndRefresh = () => {
        closeEditImageDialog();
        getEvent();
    }

    return (
        <Grid container direction="row">
            <Grid item xs={12}>
                <div className={classes.section}>
                    <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                        spacing={3}
                        className={classes.marginBottom}
                        >
                        <Grid item>
                            <Typography variant="h6" component="h3">
                                Event Image
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={event.image ? openEditImageDialog : openEditFileDialog}
                                disabled={loading}
                                >
                                {event.image ? 'Edit Image' : 'Select Image'}
                            </Button>
                            {event.image &&
                                <RedButton
                                    variant="outlined"
                                    onClick={deleteImage}
                                    className={classes.marginLeft}
                                    disabled={loading}
                                    >
                                    Remove Image
                                </RedButton>
                            }
                        </Grid>
                    </Grid>
                    <Typography color="textSecondary" className={classes.marginBottom}>
                        The event image is used on the top of the event page and should be a jpeg atleast 1800 pixels wide and 400 pixels tall.
                    </Typography>
                    {(event.image && event.image.full_url) &&
                        <HeaderImage backgroundImage={event.image.full_url}/>
                    }
                </div>
                <SelectFileDialog
                    open={editFileDialogOpen}
                    onSelect={closeEditFileDialogAndRefresh}
                    onClose={closeEditFileDialog}
                />
                {event.image &&
                    <EditImageDialog
                        file={event.image}
                        serverUrl="/admin/file/edit/image"
                        open={editImageDialogOpen}
                        onSave={closeEditImageDialogAndRefresh}
                        onClose={closeEditImageDialog}
                        editorWidth={1000}
                        editorHeight={300}
                        dialogSize='lg'
                    />
                }
            </Grid>
        </Grid>
    )
}
